import { j as s, c as d } from "./utils-BdNIfrGQ.js";
import * as f from "react";
import { n as c } from "./normalize-gap-CHOQjV8I.js";
import { n as p } from "./normalize-spacing-DY0KSpr_.js";
import { S as m } from "./index-5pXbvMI7.js";
import { c as g } from "./index-Di82Y7n3.js";
const b = g(
  "whitespace-nowrap inline-flex max-w-full items-center justify-center ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-border bg-background text-inherit hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "bg-transparent text-inherit hover:bg-accent hover:text-accent-foreground",
        link: "bg-transparent text-inherit hover:bg-transparent underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 py-2 w-full px-7",
        sm: "h-fit py-3 px-5 w-fit",
        lg: "h-11 px-8 text-lg",
        icon: "h-10 w-10 p-0 flex-shrink-0",
        "icon-sm": "h-7 w-7 p-0 flex-shrink-0",
        full: "h-fit w-full p-0"
      },
      rounded: {
        default: "rounded-full",
        md: "rounded-md",
        none: ""
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      rounded: "default"
    }
  }
), u = f.forwardRef(
  ({ className: e, variant: t, size: r, rounded: n, asChild: o = !1, ...a }, i) => {
    const l = o ? m : "button";
    return /* @__PURE__ */ s.jsx(
      l,
      {
        className: d(b({ variant: t, size: r, rounded: n, className: e })),
        ref: i,
        ...a
      }
    );
  }
);
u.displayName = "Button";
const h = f.forwardRef(
  ({ variant: e, size: t, rounded: r, spacing: n, gap: o, ...a }, i) => /* @__PURE__ */ s.jsx(
    u,
    {
      rounded: r,
      size: t,
      variant: e,
      className: d(p(n), c(o)),
      ref: i,
      ...a
    }
  )
);
h.displayName = "Button";
export {
  u as B,
  h as a,
  b
};
